export default {
  productInfo: {
    AddRow: 'Add Row',
    Save: 'save',
    Ok: 'Ok',
    Cancel: 'Cancel',
    Search: 'Search',
    ProductSelect: 'Product Select',
    ProductName: 'Product Name',
    ProductType: 'Product Type',
    ProductStatus: 'Product Status',
    ProductTradeMark: 'Product TradeMark',
    ProductCode: 'Product Code',
    ProductAttribute1: 'Product Attribute 1',
    ProductAttribute2: 'Product Attribute 2',
    StockQuantity: 'Stock Quantity',
    BasePriceValue: 'Base Price Value',
    GoodsNo: 'Goods No',
    RetailPrice: 'Retail Price',
    Unit: 'Unit',
    Status: 'Status',
    CreateTime: 'Create Time',
    ModifyTime: 'Modify Time',
    UpperShelf: 'Upper Shelf',
    LowerShelf: 'Lower Shelf',
    New_Product: 'New Product',
    OldProduct: 'Old Product',
    // 新增
    BasicData: 'Basic Data',
    BasicInfo: 'Basic Info',
    Designer: 'Designer',
    SeqNo: 'SeqNo',
    Label: 'Label',
    NewProduct: 'New Product',
    Specs: 'Specs',
    ProductDetails: 'Product Details',
    Enclosure: 'Enclosure',
    UploadSpecification: 'Upload Specification',
    UploadInstallPic: 'Upload Install Pic',
    ShieldCustomer: 'Shield Customer',
    CustomerCode: 'Customer Code',
    CustomerName: 'Customer Name',
    // 第二个标签页
    PriceSetting: 'Price Setting',
    UnitType: 'Unit Type',
    BasicUnit: 'Basic Unit',
    SupUnit: 'Sup Unit',
    UnitName: 'Unit Name',
    FirstWholesalePrice: 'First Wholesale Price',
    SecondWholesalePrice: 'Second Wholesale Price',
    ThirdWholesalePrice: 'Third Wholesale Price',
    FourWholesalePrice: 'Four Wholesale Price',
    FiveWholesalePrice: 'Five Wholesale Price',
    AllowWholesalerOrder: 'Allow Wholesaler Order',
    // 第三个标签页
    ProductAttribute: 'Product Attribute',
    UploadPic: 'Upload Pic',
    // 第四个标签页
    ProductPic: 'Product Pic',
    ListPic: 'List Pic',
    Pic1: 'Pic 1',
    Pic2: 'Pic 2',
    Pic3: 'Pic 3',
    Pic4: 'Pic 4',
    // 弹出框
    PleaseChooseProductTradeMark: 'Please Choose Product TradeMark',
    TrademarkCode: 'Trademark Code',
    TrademarkName: 'Trademark Name',
    PleaseChooseProductType: 'Please Choose ProductType',
    PleaseChooseProduct: 'Please Choose Product',
    PleaseChooseOneProduct: 'Please Choose One Product',
    TypeCode: 'Type Code',
    TypeName: 'Type Name',
    PleaseChooseDesigner: 'Please Choose Designer',
    DesignerCode: 'Designer Code',
    DesignerName: 'Designer Name',
    ProductNameCannotBeEmpty: 'Product Name Cannot Be Empty',
    ProductCodeCannotBeEmpty: 'Product Code Cannot Be Empty'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/lang/en/pmc/productInfo.js